import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArticleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"article"}/>
}
